export enum BulkUploadStatus {
    Draft = 0,
    Processing = 1,
    Error = 2,
    Processed = 3
}